import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';


@Component({
  selector: 'app-login',
  imports: [CommonModule, ReactiveFormsModule, InputTextModule, ButtonModule],
  templateUrl: './login.component.html'
})
export class LoginComponent {

  private readonly TOKEN_KEY = 'auth_token';
  private readonly NAME_USER = 'user_name';
  private readonly USER_ID = 'user_id';
  private readonly COMPANY_ID = 'company_id';
  private readonly ENABLED_MODULES = 'enabled_modules';
  form: FormGroup;
  showPassword = false;
  isLoading = false;
  error = '';

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.form = this.fb.group({
      login: ['', [Validators.required]],
      password: ['', Validators.required]
    });

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/app/dashboard']);
    }
  }

  async onSubmit() {
    if (this.form.invalid) return;

    this.isLoading = true;
    this.error = '';
    let success = false;

    const { login, password } = this.form.value;

    this.authService.login(login, password).subscribe({
      next: (data) =>{
        success = true;
        localStorage.setItem(this.TOKEN_KEY, data.token);
        localStorage.setItem(this.NAME_USER, data.fullName);
        localStorage.setItem(this.USER_ID, String(data.id));
        localStorage.setItem(this.COMPANY_ID, String(data.companyId ?? 1));
        localStorage.setItem(this.ENABLED_MODULES, JSON.stringify(data.enabledModules ?? []));
        this.router.navigate(['/app/dashboard']);
      },
      error: (error) => {
        this.error = 'Credenciais inválidas';
        this.isLoading = false;
      }
    });
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
}
